import { useCallback, useRef, useState } from 'react';
function useCurrentState(initialState) {
    const [state, setState] = useState(initialState);
    const currentState = useRef(initialState);
    const setValue = useCallback((val) => {
        const result = val instanceof Function ? val(currentState.current) : val;
        currentState.current = result;
        setState(result);
    }, [setState]);
    return [state, setValue, currentState];
}
export default useCurrentState;
//# sourceMappingURL=use-current-state.js.map